<template>
  <div class="short-container">
    <div class="p-4 mb-5">
      <div class="row">
        <div class="col-12 col-md-4 col-sm-3">
          <statusChanger :item="item" />
        </div>
        <div class="col-12 col-md-4 col-sm-3">
          <changeHighlight
            :item_id="item.id"
            :highlight="item?.highlight"
          />
        </div>
        <div class="col-12 col-md-4 col-sm-3">
          <deleteItem
            :item_id="item.id"
            :redirectRoute="discardroute"
          />
        </div>
      </div>
    </div>

    <div class="card p-4">
      <div class="row upload-container">
        <div class="col-12 col-sm-6 col-md-4 col-lg-3 order-1">
          <div
            class="loading-video"
            v-if="!loadingItem"
          ></div>
          <previewVideo
            v-else
            :video_url="video"
            :name="file?.name"
            :video_source="video_source"
            @handleVideoUpload="handleVideoUpload"
            :disabled="!startEdit"
            :key="video"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-8 col-lg-9 order-2">
          <form>
            <div class="mb-3">
              <label
                for="title"
                class="form-label"
                >Title</label
              >
              <input
                type="text"
                class="form-control"
                id="title"
                aria-describedby="titleHelp"
                placeholder="Enter title"
                v-model="form.title"
                :disabled="!startEdit"
              />
              <div
                id="titleHelp"
                class="form-text"
              >
                Enter title of the video
              </div>
            </div>
            <div class="mb-3">
              <label
                for="description"
                class="form-label"
                >Description</label
              >
              <textarea
                id="description"
                required
                cols="10"
                rows="5"
                class="form-control resize--none"
                v-model="form.description"
                :disabled="!startEdit"
              ></textarea>
            </div>

            <div
              class="mb-3"
              v-if="handleNullablePlaylist()"
            >
              <label
                for="playlist"
                class="form-label"
                >PlayLists</label
              >
              <multiselect
                v-model="form.playlist"
                :options="playlistOptions"
                placeholder="Select playlist"
                track-by="id"
                label="name"
              ></multiselect>
            </div>

            <div class="mb-3">
              <label
                for="tags"
                class="form-label"
                >Tags</label
              >
              <multiselect
                v-model="form.tags"
                tag-placeholder="Add this as new tag"
                placeholder="Add tags"
                label="name"
                track-by="name"
                :options="options"
                :multiple="true"
                :taggable="true"
                @tag="addTag"
                :disabled="!startEdit"
              ></multiselect>
              <div
                id="tagsHelp"
                class="form-text"
              >
                Enter tags for the video
              </div>
            </div>

            <div class="mb-3">
              <label
                for="item Category"
                class="form-label"
                >Item Category</label
              >
              <multiselect
              :disabled="!startEdit"
                v-model="form.item_category"
                :options="getItemCategories()"
                placeholder="Select Item Category"
                track-by="value"
                label="title"
              ></multiselect>
            </div>

            <div class="mb-3">
              <label
                for="thumbnail"
                class="form-label"
                >Thumbnail (Optional)</label
              >
              <div
                class="current_image"
                v-if="!startEdit"
              >
                <img
                  :src="item.image_portrait"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <upload-images
                v-else
                :multiple="false"
                label="Click or drag and drop to upload A Thumbnail (Optional)"
                v-model="form.thumbnail"
                :disabled="!startEdit"
              />
            </div>
            <div class="mb-3">
              <label
                for="cloudflare_id"
                class="form-label"
                >Cloudflare ID (Optional)</label
              >
              <input
                type="text"
                class="form-control"
                id="cloudflare_id"
                aria-describedby="cloudflare_idHelp"
                placeholder="Enter cloudflare id"
                v-model="form.cloudflare_id"
                :disabled="!startEdit"
              />
            </div>

            <div class="mb-3 d-flex d-none">
              <div class="checkbox__body">Mark as Highlight</div>
              <label class="checkbox style-e">
                <input
                  type="checkbox"
                  v-model="form.highlight"
                  :disabled="!startEdit"
                />
                <div class="checkbox__checkmark"></div>
              </label>
            </div>

            <div
              class="mt-35 mb-4 row d-flex justify-content-center items-center"
              v-if="!startEdit"
            >
              <button
                class="btn btn-primary align-middle col-3 ml-10"
                @click.prevent="handleStartEdit"
              >
                Start Edit
              </button>
            </div>

            <div
              class="mt-35 mb-4 row d-flex justify-content-center items-center"
              v-else
            >
              <button
                type="button"
                class="btn btn-danger col-3"
                @click.prevent="handleDiscard"
              >
                Discard
              </button>
              <button
                class="btn btn-primary align-middle col-3 ml-10"
                @click.prevent="submit"
                :disabled="loading"
              >
                {{ loading ? 'Uploading...' : 'Upload' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="card p-4 mt-35">
      <div class="row">
        <h1 class="views-title">View Comments</h1>

        <div class="col-12">
          <!-- table for responsive and only comments -->
          <div class="table-responsive--sm table-responsive">
            <table class="table table--light style--two">
              <thead>
                <tr>
                  <th scope="col">Comment</th>
                  <th scope="col">Commented By</th>
                  <th scope="col">Commented On</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <!-- <tr>
                <td>Comment</td>
                <td>Commented By</td>
                <td>Commented On</td>
                <td>
                  <button class="btn btn-danger">Delete</button>
                </td>
              </tr> -->
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import previewVideo from '../components/preview-video.vue';
import ItemTypeComponent from '../../components/ItemTypeComponent';
import Multiselect from 'vue-multiselect';
import UploadImages from '../../components/upload-images';
import axios from 'axios';
import statusChanger from './components/status-changer';
import deleteItem from './components/delete-item';
import changeHighlight from './components/change-highlight.vue';

export default {
  name: 'DetailsItem',
  components: {
    previewVideo,
    Multiselect,
    ItemTypeComponent,
    UploadImages,
    statusChanger,
    deleteItem,
    changeHighlight,
  },

  props: ['plans', 'route', 'item', 'playlist', 'discardroute', 'category'],

  data() {
    return {
      video: null,
      file: null,
      versions: [
        { value: 0, title: 'Video is Free' },
        { value: 1, title: 'Video is Paid' },
      ],
      categories: [
        { value: 'action', title: 'Action' },
        { value: 'comedy', title: 'Comedy' },
        { value: 'drama', title: 'Drama' },
        { value: 'horror', title: 'Horror' },
        { value: 'romance', title: 'Romance' },
        { value: 'thriller', title: 'Thriller' },
      ],
      options: [],
      playlistOptions: [],
      form: {
        item_type: 1,
        version: 0,
        // plans: [],
        tags: [],
        video: null,
        thumbnail: null,
        title: '',
        description: '',
        highlight: false,
        playlist: null,
        cloudflare_id: '',
        item_category: {
          value: '',
          title: '',
        },
      },
      loading: false,
      startEdit: false,
      loadingItem: false,
      video_source: 'local',
      video_changed: false,
    };
  },

  mounted() {
    this.handleOnBaordInputs();

    if (this.handleNullablePlaylist()) {
      this.handleGetActivePlaylists();
    }
  },
  methods: {
    handleVideoUpload({ file, videoUrl }) {
      this.file = file;
      this.video = videoUrl;
      this.video_source = 'local';
      this.video_changed = true;
      this.form.title = this.file.name;
    },
    getItemCategories() {
      const categories = [];
      this.category?.forEach((category) => {
        categories.push({
          value: category.id,
          title: category.name,
        });
      });
      return categories;
    },

    changeVersion(version) {
      this.form.version = version;
      this.form.thumbnail = null;
    },
    nameWithLang({ name, pricing, duration }) {
      return `${name} — ${Number(pricing)} RWF for ${duration} days`;
    },

    addTag(newTag) {
      const tag = {
        name: newTag,
      };
      this.options.push(tag);
      this.form.tags.push(tag);
    },

    removeTag(tag) {
      const index = this.form.tags.indexOf(tag);
      if (index >= 0) {
        this.form.tags.splice(index, 1);
      }
    },

    async submit() {
      if (this.file == null) {
        notify('error', 'Uploading video is required');
        return;
      }

      try {
        this.loading = true;
        const formData = new FormData();
        formData.append('title', this.form.title);
        formData.append('description', this.form.description);
        for (let i = 0; i < this.form?.tags?.length; i++) {
          formData.append('tags[]', this.form?.tags[i].name);
        }

        formData.append('version', this.form.version);
        formData.append('item_type', this.form.item_type);

        formData.append('highlight', this.form.highlight);

        if (this.video_changed == true && this.form.cloudflare_id == '') {
          formData.append('video', this.file);
        }

        if (this.handleNullablePlaylist()) {
          formData.append('flix_playlist_id', this.form.playlist?.value);
        } else {
          formData.append('flix_playlist_id', this.item.flix_playlist_id);
        }

        if (this.form.cloudflare_id !== '') {
          formData.append('cloudflare_id', this.form.cloudflare_id);
        }

        if (this.form.thumbnail)
          formData.append('thumbnail', this.form.thumbnail[0].image);

        if (this.form.item_category.value !== '') {
          formData.append('item_category', this.form.item_category?.value);
        }
        const res = await axios.post(this.route, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        
        if (res.data.errors) {

          notify('error', res.data.errors);
        } else {
          notify('success', 'Post uploaded successfully!');

          this.reset();
          window.location = this.discardroute;
        }
      } catch (e) {
        console.log(this.form.item_type);

        notify('error', 'Something went wrong');
        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    reset() {
      this.form = {
        item_type: 1,
        version: 0,
        tags: [],
        video: null,
        title: '',
        description: '',
        playlist: null,
        thumbnail: null,
        highlight: null,
        item_category: {
          value: '',
          title: '',
        },
      };
    },

    handleDiscard() {
      window.addEventListener('beforeunload', function (event) {
        event.preventDefault();
        event.returnValue = 'Are you sure you want to leave this page?';
      });
      window.location = this.discardroute;
    },

    handleStartEdit() {
      this.startEdit = true;
    },

    handleOnBaordInputs() {
      this.form.item_type = this.item.item_type;
      this.form.title = this.item.title;
      this.form.description = this.item.description;
      this.form.highlight = this.item.highlight;
      this.form.thumbnail = this.item.image_portrait;
      this.form.video = this.item.video_url;
      this.form.cloudflare_id = this.item?.video?.content;
      this.video = this.item.video_url;
      this.video_source = this.item?.video?.video_source;
      this.file = {
        name: this.item.title,
      };
      this.form.item_category = this.getItemCategory();

      const currentTags = this.item.tags.split(',');
      this.options.push(
        ...currentTags.map((tag) => {
          return {
            name: tag,
          };
        }),
      );
      this.form.tags.push(
        ...currentTags.map((tag) => {
          return {
            name: tag,
          };
        }),
      );
      this.loadingItem = true;
    },

    handleGetActivePlaylists() {
      this.playlistOptions.push({ value: null, name: 'No Playlist' });
      axios
        .get('/creator/flix-playlist/all')
        .then((res) => {
          var playlists = res.data.data;
          playlists?.forEach((playlist) => {
            this.playlistOptions.push({
              value: playlist.id,
              name: playlist.name,
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    handleNullablePlaylist() {
      if (this.playlist == 'null') {
        return true;
      }
      return false;
    },
    getItemCategory() {
      const category_id = this.item?.category_id;
      const Icategory = this.category?.find(
        (category) => category?.id == category_id,
      );
      return {
        value: Icategory?.id,
        title: Icategory?.name,
      };
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.upload-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.btn-primary {
  padding: 10px 20px;
  text-align: center;
  border-radius: 3px;
  cursor: pointer;
  border: solid #0f4c47 1px;
  color: white;
  background-color: #0f4c47;
  transition: 0.2s;

  &:hover {
    background-color: #ffff;
    color: #0f4c47;
  }
}
@media screen and (max-width: 768px) {
  .order-1 {
    order: 2;
  }
  .order-2 {
    order: 1;
  }
}

.style-e {
  display: inline-block;
  position: relative;
  padding-left: 50px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.style-e input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.style-e input:checked ~ .checkbox__checkmark {
  background-color: #0f4c47;
}
.style-e input:checked ~ .checkbox__checkmark:after {
  left: 21px;
}
.style-e:hover input ~ .checkbox__checkmark {
  background-color: #eee;
}
.style-e:hover input:checked ~ .checkbox__checkmark {
  background-color: #0f4c47;
}
.style-e .checkbox__checkmark {
  position: absolute;
  top: 1px;
  left: 0;
  height: 22px;
  width: 40px;
  background-color: #eee;
  transition: background-color 0.25s ease;
  border-radius: 11px;
}
.style-e .checkbox__checkmark:after {
  content: '';
  position: absolute;
  left: 3px;
  top: 3px;
  width: 16px;
  height: 16px;
  display: block;
  background-color: #fff;
  border-radius: 50%;
  transition: left 0.25s ease;
}

.checkbox__body {
  color: #333;
  line-height: 1.4;
  transition: color 0.25s ease;
  margin-right: 10px;
}
.loading-video {
  height: 500px;
  width: 100%;
  background-color: rgb(159, 157, 157);
  border-radius: 5px;
}
.current_image {
  height: 150px;
  width: 100%;
  border-radius: 5px;
}

.current_image img {
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}
.resize--none {
  resize: none;
}
.views-title {
  font-size: 20px;
  font-weight: 600;
  color: #323131;
  margin-bottom: 10px;
}
.item-change-status {
  margin-left: 10px;
}
</style>
